import React from "react";

const RangeSlider = ({
  id,
  label,
  min = 0,
  max = 100,
  step = 1,
  value,
  disabled = false,
  size = "medium",
  onChange,
}) => {
  const sizeClasses = {
    small: "h-1",
    medium: "h-2",
    large: "h-3",
  };

  return (
    <div className="mb-6">
      {label && (
        <div>
          <label
            htmlFor={id}
            className="block text-sm font-medium text-gray-900 font-poppin"
          >
            {label}
          </label>
        </div>
      )}
      <div className="flex items-center justify-between">
        <div className="w-[75%]">
          <input
            name={id}
            id={id}
            type="range"
            min={min}
            max={max}
            step={step}
            value={value}
            disabled={disabled}
            onChange={onChange}
            className={`w-full ${sizeClasses[size]} bg-gray-200 rounded-lg appearance-none cursor-pointer  font-poppin`}
          />
        </div>
        <div className="w-[20%] border border-[#BBBBBB] p-2 rounded-md">
          <p className="text-sm font-poppin">{value}</p>
        </div>
      </div>
    </div>
  );
};

export default RangeSlider;
